
import { useState } from 'react';

const Activities = () => {
  const [activeTab, setActiveTab] = useState('physical');

  const activityCategories = {
    physical: {
      title: 'Physical Activities',
      icon: 'ri-run-line',
      activities: [
        {
          name: 'Chair Exercises',
          description: 'Gentle exercises designed for all mobility levels',
          image: 'https://public.readdy.ai/ai/img_res/78f492554d78948324509e0e486d79b8.jpg'
        },
        {
          name: 'Walking Groups',
          description: 'Supervised walks in our beautiful garden areas',
          image: 'https://readdy.ai/api/search-image?query=Group%20of%20seniors%20walking%20together%20in%20a%20beautiful%20garden%20setting%2C%20paved%20walking%20paths%2C%20lush%20greenery%20and%20flowers%2C%20seniors%20using%20walking%20aids%2C%20caregiver%20accompanying%20the%20group%2C%20peaceful%20outdoor%20environment&width=300&height=200&seq=walking-group&orientation=landscape'
        },
        {
          name: 'Balance Training',
          description: 'Safe exercises to improve stability and prevent falls',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20participating%20in%20balance%20training%20exercises%20with%20professional%20instructor%2C%20safety%20mats%20and%20equipment%2C%20supportive%20environment%2C%20focus%20on%20stability%20and%20coordination%2C%20modern%20exercise%20room%20with%20proper%20lighting&width=300&height=200&seq=balance-training&orientation=landscape'
        }
      ]
    },
    mental: {
      title: 'Mental Stimulation',
      icon: 'ri-brain-line',
      activities: [
        {
          name: 'Memory Games',
          description: 'Fun activities to keep minds sharp and engaged',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20playing%20memory%20games%20and%20puzzles%20at%20tables%2C%20concentration%20and%20focus%2C%20colorful%20game%20pieces%20and%20cards%2C%20social%20interaction%20while%20thinking%2C%20bright%20and%20cheerful%20activity%20room&width=300&height=200&seq=memory-games&orientation=landscape'
        },
        {
          name: 'Reading Circles',
          description: 'Book discussions and storytelling sessions',
          image: 'https://readdy.ai/api/search-image?query=Group%20of%20elderly%20people%20sitting%20in%20comfortable%20chairs%20reading%20books%20together%2C%20cozy%20library%20setting%2C%20natural%20lighting%2C%20bookshelves%20in%20background%2C%20peaceful%20reading%20atmosphere%2C%20seniors%20engaged%20in%20discussion&width=300&height=200&seq=reading-circle&orientation=landscape'
        },
        {
          name: 'Brain Training',
          description: 'Cognitive exercises and puzzles',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20working%20on%20crossword%20puzzles%20and%20brain%20training%20activities%2C%20focused%20concentration%2C%20pencils%20and%20puzzle%20books%2C%20comfortable%20seating%2C%20encouraging%20environment%20for%20mental%20exercise&width=300&height=200&seq=brain-training&orientation=landscape'
        }
      ]
    },
    creative: {
      title: 'Creative Arts',
      icon: 'ri-palette-line',
      activities: [
        {
          name: 'Art Therapy',
          description: 'Painting, drawing, and creative expression',
          image: 'https://readdy.ai/api/search-image?query=Elderly%20people%20engaged%20in%20art%20therapy%2C%20painting%20on%20canvases%20and%20paper%2C%20colorful%20paints%20and%20brushes%2C%20creative%20expression%2C%20art%20instructor%20guiding%20the%20session%2C%20bright%20art%20studio%20with%20natural%20light&width=300&height=200&seq=art-therapy&orientation=landscape'
        },
        {
          name: 'Music Sessions',
          description: 'Singing, instrument playing, and music appreciation',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20participating%20in%20music%20therapy%20session%2C%20singing%20together%2C%20musical%20instruments%20like%20piano%20and%20tambourines%2C%20joyful%20expressions%2C%20music%20therapist%20leading%20the%20group%2C%20warm%20and%20inviting%20music%20room&width=300&height=200&seq=music-session&orientation=landscape'
        },
        {
          name: 'Crafts Workshop',
          description: 'Hands-on crafting and creative projects',
          image: 'https://readdy.ai/api/search-image?query=Group%20of%20seniors%20working%20on%20craft%20projects%2C%20knitting%2C%20scrapbooking%2C%20and%20handmade%20items%2C%20craft%20supplies%20and%20materials%20on%20tables%2C%20collaborative%20creative%20work%2C%20satisfied%20expressions%20while%20creating&width=300&height=200&seq=crafts-workshop&orientation=landscape'
        }
      ]
    },
    social: {
      title: 'Social Activities',
      icon: 'ri-group-line',
      activities: [
        {
          name: 'Game Tournaments',
          description: 'Friendly competitions and board games',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20playing%20board%20games%20and%20card%20games%20together%2C%20competitive%20but%20friendly%20atmosphere%2C%20game%20pieces%20and%20cards%20on%20tables%2C%20laughter%20and%20social%20interaction%2C%20comfortable%20game%20room%20setting&width=300&height=200&seq=game-tournament&orientation=landscape'
        },
        {
          name: 'Social Hours',
          description: 'Coffee time and conversation groups',
          image: 'https://readdy.ai/api/search-image?query=Elderly%20people%20enjoying%20coffee%20and%20conversation%20in%20a%20comfortable%20lounge%20area%2C%20soft%20seating%20arrangements%2C%20warm%20beverages%2C%20friendly%20social%20interaction%2C%20cozy%20atmosphere%20with%20natural%20lighting&width=300&height=200&seq=social-hour&orientation=landscape'
        },
        {
          name: 'Special Events',
          description: 'Holiday celebrations and themed parties',
          image: 'https://readdy.ai/api/search-image?query=Seniors%20celebrating%20at%20a%20special%20event%20party%2C%20decorations%20and%20festive%20atmosphere%2C%20group%20photo%20opportunity%2C%20smiling%20faces%2C%20celebration%20cake%20and%20refreshments%2C%20joyful%20community%20gathering&width=300&height=200&seq=special-event&orientation=landscape'
        }
      ]
    }
  };

  const tabs = [
    { key: 'physical', label: 'Physical', icon: 'ri-run-line' },
    { key: 'mental', label: 'Mental', icon: 'ri-brain-line' },
    { key: 'creative', label: 'Creative', icon: 'ri-palette-line' },
    { key: 'social', label: 'Social', icon: 'ri-group-line' }
  ];

  return (
    <section id="activities" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Engaging Daily Activities
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our diverse range of activities is designed to stimulate the mind, body, and spirit while fostering meaningful connections and personal growth.
          </p>
        </div>

        <div className="flex flex-wrap justify-center mb-12 gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                activeTab === tab.key
                  ? 'bg-orange-600 text-white shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${tab.icon} text-lg`}></i>
              </div>
              {tab.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activityCategories[activeTab as keyof typeof activityCategories].activities.map((activity, index) => (
            <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src={activity.image}
                alt={activity.name}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {activity.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {activity.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Weekly Activity Schedule
            </h3>
            <p className="text-gray-600 mb-6">
              Our activities run Monday through Friday, with special weekend events throughout the month.
            </p>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center">
              <div className="p-4 bg-orange-50 rounded-lg">
                <div className="font-semibold text-orange-600">Monday</div>
                <div className="text-sm text-gray-600 mt-1">Physical & Arts</div>
              </div>
              <div className="p-4 bg-orange-50 rounded-lg">
                <div className="font-semibold text-orange-600">Tuesday</div>
                <div className="text-sm text-gray-600 mt-1">Mental & Music</div>
              </div>
              <div className="p-4 bg-orange-50 rounded-lg">
                <div className="font-semibold text-orange-600">Wednesday</div>
                <div className="text-sm text-gray-600 mt-1">Social & Games</div>
              </div>
              <div className="p-4 bg-orange-50 rounded-lg">
                <div className="font-semibold text-orange-600">Thursday</div>
                <div className="text-sm text-gray-600 mt-1">Creative & Crafts</div>
              </div>
              <div className="p-4 bg-orange-50 rounded-lg">
                <div className="font-semibold text-orange-600">Friday</div>
                <div className="text-sm text-gray-600 mt-1">Special Events</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Activities;
